(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector("[data-ushare-quote]");
    if (!root) return;
    var form = root.querySelector("#UshareQuoteForm");
    if (!form) return;
    var pref = root.querySelector("[data-pref]");
    var wa = root.querySelector("#UshareQuote-wa");
    var fb = root.querySelector("#UshareQuote-fb");
    var body = root.querySelector("[data-quote-body]");

    function val(sel) {
      var el = root.querySelector(sel);
      return el ? String(el.value || "").trim() : "";
    }

    form.addEventListener("submit", function (e) {
      var hasPref = (wa && wa.value.trim()) || (fb && fb.value.trim());
      if (!hasPref) {
        e.preventDefault();
        if (pref) pref.classList.add("is-invalid");
        if (wa) wa.focus();
        return;
      }
      if (pref) pref.classList.remove("is-invalid");
      if (body) {
        body.value = [
          "Free consultation request",
          "Name: " + val("#UshareQuote-name"),
          "Age: " + val("#UshareQuote-age"),
          "Gender: " + val("#UshareQuote-gender"),
          "Country: " + val("#UshareQuote-country"),
          "Email: " + val("#UshareQuote-email"),
          "Phone: " + val("#UshareQuote-phone"),
          "WhatsApp: " + val("#UshareQuote-wa-code") + " " + val("#UshareQuote-wa"),
          "Facebook Messenger: " + val("#UshareQuote-fb"),
          "Procedure: " + val("#UshareQuote-procedure"),
          "Hospital: " + val("#UshareQuote-hospital"),
          "Travel city: " + val("#UshareQuote-city"),
          "Timeline: " + val("#UshareQuote-when"),
          "Notes: " + val("#UshareQuote-notes"),
          "Consent: " + (root.querySelector("#UshareQuote-consent") && root.querySelector("#UshareQuote-consent").checked ? "Yes" : "No")
        ].join("\n");
      }
    });

    function fillFromQuery() {
      var params = new URLSearchParams(window.location.search);
      var hospital = params.get("hospital");
      var city = params.get("city");
      var procedure = params.get("procedure");
      var hospitalInput = root.querySelector("#UshareQuote-hospital");
      var citySelect = root.querySelector("#UshareQuote-city");
      var procedureInput = root.querySelector("#UshareQuote-procedure");
      if (hospital && hospitalInput && !hospitalInput.value) hospitalInput.value = hospital;
      if (procedure && procedureInput && !procedureInput.value) procedureInput.value = procedure;
      if (city && citySelect) {
        var wanted = city.replace(/-/g, " ").toLowerCase();
        Array.prototype.forEach.call(citySelect.options, function (opt) {
          if (opt.value && opt.value.toLowerCase() === wanted) citySelect.value = opt.value;
        });
      }
    }
    fillFromQuery();

    function clearPref() {
      if (pref) pref.classList.remove("is-invalid");
    }
    if (wa) wa.addEventListener("input", clearPref);
    if (fb) fb.addEventListener("input", clearPref);
  });
})();
